import { createFetcherContext } from './meetingRoomAvailability/context.js';
import { fetchMeetingRoomData } from './meetingRoomAvailability/fetchMeetingRoomData.js';
import type { FetcherDependencies } from './meetingRoomAvailability/types.js';

export const createMeetingRoomAvailabilityFetcher = (deps: FetcherDependencies) => {
  const context = createFetcherContext(deps);

  return {
    fetch: () => fetchMeetingRoomData(context),
  };
};

export type MeetingRoomAvailabilityFetcher = ReturnType<
  typeof createMeetingRoomAvailabilityFetcher
>;
